enum SocialMediaEnum {
    FACEBOOK  = "facebook",
    PINTEREST = "pinterest",
    TWITTER   = "twitter",
    INSTAGRAM  = "instagram",
    WHATSAPP = "whatsapp",
    UNDEFINED = "",
}

export default SocialMediaEnum;
